import { gql } from '@apollo/client/core'

export const GET_EVENTS = gql`
  query GetEvents($input: GetEventsInput!) {
    getEvents(input: $input) {
      event_id
      uuid
      event_title
      notes
      internal_notes
      practice_id
      creator_calendar_id
      event_type
      color_id
      external_url
      google_event_id
      outlook_event_id
      zoom_event_id
      is_canceled
      start_time
      end_time
      location
      timezone
      rrule
      recurrence_id
      patient_ids
      accession_ids
      create_time
      update_time
      participants {
        id
        event_id
        participant_calendar_id
        role
        status
        created_at
        updated_at
        firstname
        lastname
      }
    }
  }
`

export const GET_EVENT_BY_EVENT_ID = gql`
  query GetEventByEventId($eventId: Int!) {
    getEventByEventId(eventId: $eventId) {
      event_id
      uuid
      event_title
      notes
      internal_notes
      practice_id
      creator_calendar_id
      event_type
      color_id
      external_url
      google_event_id
      outlook_event_id
      zoom_event_id
      is_canceled
      start_time
      end_time
      location
      timezone
      rrule
      recurrence_id
      patient_ids
      create_time
      update_time
      participants {
        id
        event_id
        participant_calendar_id
        participant_id
        role
        status
        created_at
        updated_at
      }
    }
  }
`

export const GET_TASKS = gql`
  query GetTasksByCreator($startDate: DateTime, $endDate: DateTime) {
    tasksByCreator(startDate: $startDate, endDate: $endDate) {
      task_id
      uuid
      calendar_id
      created_by
      title
      description
      priority
      category
      is_completed
      is_active
      start_date
      due_date
      rrule
      created_at
      updated_at
    }
  }
`

export const GET_TASKS_BY_CLINIC = gql`
  query GetTasksByClinic($startDate: DateTime, $endDate: DateTime) {
    tasksByClinic(startDate: $startDate, endDate: $endDate) {
      tasks {
        task_id
        uuid
        calendar_id
        created_by
        title
        description
        priority
        category
        is_completed
        is_active
        start_date
        due_date
        rrule
        created_at
        updated_at
      }
      openedTaskCount
    }
  }
`

export const GET_TASK = gql`
  query GetTask($id: Int!) {
    task(id: $id) {
      task_id
      uuid
      calendar_id
      practice_id
      created_by
      title
      description
      priority
      is_completed
      is_active
      start_date
      due_date
      end_date
      rrule
      created_at
      updated_at
      category
    }
  }
`
// as provider fetch meeting requests
export const GET_MEETING_REQUESTS_FOR_ME = gql`
  query getMeetingRequestsForMe{
    getMeetingRequestsForMe{
      id
      uuid
      patient_calendar_id
      provider_calendar_id
      # patient_id
      patient_firstname
      patient_lastname
      is_conflicted
      provider {
        # calendar_id
        customer_id
        first_name
        last_name
      }
      clinic {
        clinic_id
        clinic_name
      }
      requested_start_time
      requested_end_time
      topic
      notes
      status
      created_at
      updated_at
      location
      event_type
    }
  }
`

export const GET_CANCELED_MEETING_REQUESTS_FOR_ME = gql`
  query GetCanceledMeetingRequests($input: GetCanceledMeetingRequestsInput!) {
    getCanceledMeetingRequests(input: $input) {
      id
      uuid
      patient_calendar_id
      patient_firstname
      patient_lastname
      provider {
        first_name
        last_name
        customer_id
      }
      clinic {
        clinic_id
        clinic_name
      }
      requested_start_time
      requested_end_time
      topic
      notes
      event_type
      location
      status
      cancellation_reason
      created_at
      updated_at
      accepted_meeting_id
      is_conflicted
    }
  }
`

export const GET_CLINIC = gql`
  query GetClinic($clinicId: Int!) {
    getClinic(clinicId: $clinicId) {
      clinic_id
      clinic_name
      clinic_customers {
        clinic_id
        customer_id
        first_name
        last_name
        is_active
        customer_role
        calendar_id
      }
      clinic_patients {
        id
        first_name
        last_name
        email
        calendar_id
      }
      locations {
        id
        uuid
        location_name
        street_address
        city
        state
        zipcode
        country
        phone
        is_active
      }
    }
  }
`

export const GET_NEXT_AVAILABLE_TIME = gql`
  query GetNextAvailableTime($input: GetNextAvailableTimeInput!) {
    getNextAvailableTime(input: $input) {
      start_time
      end_time
    }
  }
`



